export class IntendedProviderParams {
  network_id?: string;
  geo_location?: string;
  locale?: string;
  data_language?: string;
  procedure_id?: string;
  radius?: string;
  transaction_id?: string;
  account_id?: string;
  ci?: string;
  member_number?: string;
  dob?: string;
  client_canonical_id?: string;

  constructor(obj?: IntendedProviderParams) {
    if (obj) {
      this.network_id = obj.network_id || null;
      this.geo_location = obj.geo_location || null;
      this.locale = obj.locale || 'en';
      this.data_language = this.locale;
      this.procedure_id = obj.procedure_id || null;
      this.radius = obj.radius || null;
      this.transaction_id = obj.transaction_id || null;
      this.account_id = obj.account_id || null;
      this.ci = obj.ci || null;
      this.member_number = obj.member_number || null;
      this.dob = obj.dob || null;
      this.client_canonical_id = obj.client_canonical_id || null;
    }
  }
}
